var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldTick = function SvgShieldTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#16A34A",
    d: "m30.9 6.867-9.167-3.434c-.95-.35-2.5-.35-3.45 0L9.117 6.867c-1.767.666-3.2 2.733-3.2 4.616v13.5c0 1.35.883 3.134 1.966 3.934l9.167 6.85c1.617 1.216 4.267 1.216 5.883 0l9.167-6.85c1.083-.817 1.967-2.584 1.967-3.934v-13.5c.016-1.883-1.417-3.95-3.167-4.616M25.8 16.2l-7.167 7.167c-.25.25-.566.366-.883.366s-.633-.116-.883-.366l-2.667-2.7a1.257 1.257 0 0 1 0-1.767 1.257 1.257 0 0 1 1.767 0l1.8 1.8 6.283-6.283a1.26 1.26 0 0 1 1.767 0c.483.483.483 1.3-.017 1.783"
  })));
};
export default SvgShieldTick;